import React from 'react'

function MemberCreate() {
  return (
    <div>MemberCreate</div>
  )
}

export default MemberCreate